import { EducationLevel } from '@/apis/types'

export const JENJANG_SD: EducationLevel = {
  id: 1,
  name: 'SD',
}

export const JENJANG_SMP: EducationLevel = {
  id: 2,
  name: 'SMP',
}

export const JENJANG_SMA: EducationLevel = {
  id: 3,
  name: 'SMA',
}

export const JENJANG_SMK: EducationLevel = {
  id: 4,
  name: 'SMK',
}

export const JENJANG_PAUD: EducationLevel = {
  id: 5,
  name: 'PAUD',
}

export const ALL_JENJANG = [
  JENJANG_SD,
  JENJANG_SMP,
  JENJANG_SMA,
  JENJANG_SMK,
  JENJANG_PAUD,
]

export const JENJANG_ID_BY_NAME = {
  SD: 1,
  SMP: 2,
  SMA: 3,
  SMK: 4,
  PAUD: 5,
}
